import React from 'react';
import { PackageCheck, AlertCircle, Clock, FileCheck, Truck, RefreshCw, Phone, Mail, Globe, CreditCard, Scale } from 'lucide-react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <>
      <div className="terms-page-container">
        <div className="terms-page-wrapper">
          <h1 className="terms-page-title">Terms & Conditions</h1>
          
          <div className="terms-page-intro">
            <PackageCheck className="terms-intro-icon" />
            <p>
              Welcome to <strong>PROPERTECK</strong>. By accessing or purchasing from our website, store, or using our services, you agree to the following Terms & Conditions. These terms apply to both individual customers and corporate/business clients.
            </p>
          </div>

          <div className="terms-page-content">
            <div className="terms-page-section">
              <h2 className="terms-section-title"><FileCheck className="terms-section-icon" /> General</h2>
              <ul className="terms-list">
                <li>All orders are accepted and processed according to the terms set out below.</li>
                <li>By placing an order, you confirm that the information provided (contact details, delivery address, business information) is accurate and complete.</li>
                <li>PROPERTECK reserves the right to update or change these Terms & Conditions at any time. The latest version will always be available on our website.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><CreditCard className="terms-section-icon" /> Pricing & Payment</h2>
              <ul className="terms-list">
                <li>Prices are listed in Sri Lankan Rupees (LKR) and are subject to change without prior notice based on market fluctuations.</li>
                <li>Payment must be made in full before delivery unless otherwise agreed (for approved corporate clients).</li>
                <li>For online payments, we use secure third-party payment gateways such as PayHere.</li>
                <li>PROPERTECK does not store credit/debit card details.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><Truck className="terms-section-icon" /> Orders & Delivery</h2>
              <ul className="terms-list">
                <li>Orders are processed after payment confirmation or agreed terms.</li>
                <li>Delivery timelines may vary based on product availability and location.</li>
                <li>Island-wide delivery is available; delivery charges may apply.</li>
                <li>PROPERTECK is not responsible for delays caused by courier or logistics providers.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><FileCheck className="terms-section-icon" /> Warranty</h2>
              <ul className="terms-list">
                <li>Warranty is provided according to the manufacturer’s warranty policy.</li>
                <li>
                  Warranty does not cover:
                  <ul className="terms-nested-list">
                    <li>Physical damage</li>
                    <li>Improper use</li>
                    <li>Liquid damage</li>
                    <li>Unauthorized repairs</li>
                  </ul>
                </li>
                <li>Customers must retain the original invoice/receipt to claim warranty.</li>
                <li>Corporate customers requiring special warranty arrangements must agree in writing.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><RefreshCw className="terms-section-icon" /> Returns & Refunds</h2>
              <ul className="terms-list">
                <li>Returns are accepted only for damaged or defective items, as stated in our Return & Refund Policy.</li>
                <li>Customers must report damaged or defective items within 3 days of delivery.</li>
                <li>Shipping/delivery fees are non-refundable except where the return is due to our error.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><AlertCircle className="terms-section-icon" /> Limitation of Liability</h2>
              <ul className="terms-list">
                <li>PROPERTECK is not liable for indirect, incidental, or consequential losses arising from the use or inability to use a purchased product.</li>
                <li>We are not responsible for data loss or damage resulting from product failure, misuse, or third-party service providers.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><Globe className="terms-section-icon" /> Use of Website</h2>
              <ul className="terms-list">
                <li>All content on our website (including images, text, and graphics) is the property of PROPERTECK and may not be reproduced or used without prior written consent.</li>
                <li>Users agree not to misuse the website or attempt unauthorized access to its systems.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><FileCheck className="terms-section-icon" /> Privacy</h2>
              <ul className="terms-list">
                <li>We respect your privacy and protect your data in line with our Privacy Policy.</li>
              </ul>
            </div>

            <div className="terms-page-section">
              <h2 className="terms-section-title"><Scale className="terms-section-icon" /> Governing Law</h2>
              <ul className="terms-list">
                <li>These Terms & Conditions are governed by the laws of Sri Lanka.</li>
                <li>Any disputes will be subject to the exclusive jurisdiction of the courts of Sri Lanka.</li>
              </ul>
            </div>

            <div className="terms-page-section terms-contact-section">
              <h2 className="terms-section-title"><Phone className="terms-section-icon" /> Contact Us</h2>
              <p>For any questions or concerns about these Terms & Conditions, please contact us:</p>
              <div className="terms-contact-details">
                <p><Phone className="terms-contact-icon" /> 077 949 0055 / 037 434 0055</p>
                <p><Mail className="terms-contact-icon" /> info@properteck.lk</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;